/**
 * Stable CSS class names for E2E — Customer payment methods.
 */
export const CPM = {
    page: 'customer-payment-methods-page',
    headerPaper: 'customer-payment-methods-page__header-paper',
    headerTableSection: 'customer-payment-methods-page__header-table-section',
    headerCellPaymentMethod: 'customer-payment-methods-page__header-cell-payment-method',
    headerCellStatus: 'customer-payment-methods-page__header-cell-status',
    headerCellNote: 'customer-payment-methods-page__header-cell-note',
    headerCellSave: 'customer-payment-methods-page__header-cell-save',
    headerCellRemoveAutoBlock: 'customer-payment-methods-page__header-cell-remove-auto-block',
    headerCellDetail: 'customer-payment-methods-page__header-cell-detail',

    methodRow: 'customer-payment-methods-page__method-row',
    methodCard: 'customer-payment-methods-page__method-card',
    methodTableSection: 'customer-payment-methods-page__method-table-section',

    fieldPaymentMethodName: 'customer-payment-methods-field--payment-method-name',
    fieldStatusControl: 'customer-payment-methods-field--status-control',
    inputSelectStatus: 'customer-payment-methods-input--select-status',
    inputTextfieldNote: 'customer-payment-methods-input--textfield-note',
    inputButtonSave: 'customer-payment-methods-input--button-save',
    inputButtonRemoveAutoBlock: 'customer-payment-methods-input--button-remove-auto-block',
    inputToggleHistory: 'customer-payment-methods-input--toggle-history',
    blockDetailSection: 'customer-payment-methods-page__block-detail-section',
    historyDatagrid: 'customer-payment-methods-page__history-datagrid',
} as const;

export const cpmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
